export default {
  basic: () => import("/home/forge/forms.indiaai.in/client/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/home/forge/forms.indiaai.in/client/layouts/default.vue").then(m => m.default || m)
}